import { useRef, useState } from 'react';
import s from './AllSpecialists.module.scss'
import { ReactComponent as IconArrow } from 'images/arrow-down-w.svg';
import useGetServicesBySalonId from 'sdk/hooks/salon/useGetServicesBySalonId';
import { useTranslation } from 'react-i18next';

interface AllSpecialistsFilterProps {
  salonId: string | undefined;
  selectedService: string;
  setSelectedService: (service: string) => void;
}

const AllSpecialistsFilter = ({
  salonId,
  selectedService,
  setSelectedService
}: AllSpecialistsFilterProps) => {
  const {t} = useTranslation() as any;
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { data: services } = useGetServicesBySalonId(salonId);

  const getServiceName = (id: string) => {
    const service = services?.find(s => s.id === id);
    return t(service?.name) || t('All');
  };

  return (
    <div className={s.all_specialists_filter}>
      <div className={s.all_specialists_filter_title}>{t('Service')}</div>
      <div
        className={s.all_specialists_filter_selection}
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <div className={s.all_specialists_filter_selection_title}>
          {getServiceName(t(selectedService))}
        </div>
        <div className={s.all_specialists_filter_selection_icon}>
          <IconArrow />
        </div>
      </div>
      {showDropdown && (
        <div className={s.dropdown_menu} ref={dropdownRef}>
          <div
            className={s.dropdown_item}
            onClick={() => {
              setSelectedService('all');
              setShowDropdown(false);
            }}
          >
            {t('All')}
          </div>
          {services?.map((service) => (
            <div
              key={service.id}
              className={s.dropdown_item}
              onClick={() => {
                setSelectedService(service.id);
                setShowDropdown(false);
              }}
            >
              {t(service.name)}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default AllSpecialistsFilter